import { Drawer } from "@mantine/core";
import { FC } from "react";
import LocationBaseballCard from "../LocationBaseballCard";

interface Props {
  placeId?: string;
  onClose: () => void;
  onCreateLead: (leadInfo: any) => void;
  onCenterOnMap: (latLon: [number, number]) => void;
  onFindOnMap: (locationDetail: any) => void;
  onPhoneClicked: (phone: string) => void;
};

const LocationBaseballCardModal: FC<Props> = ({
  placeId,
  onClose,
  onCreateLead,
  onCenterOnMap,
  onFindOnMap,
  onPhoneClicked
}) => {
  return (
    <Drawer
      opened={!!placeId}
      zIndex={5001}
      size="xl"
      radius="30px 30px 0 0"
      onClose={() => {
        onClose();
      }}
      position="bottom"
      styles={{
        header: {
          display: "none"
        },
        body: {
          height: "100%",
          boxSizing: "border-box"
        }
      }}
    >
      <LocationBaseballCard
        placeId={placeId}
        onClose={onClose}
        onCreateLead={onCreateLead}
        onCenterOnMap={onCenterOnMap}
        onFindOnMap={onFindOnMap}
        onPhoneClicked={onPhoneClicked}
      />
    </Drawer>
  );
};

export default LocationBaseballCardModal;

